// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (federalHighwayFare) => ({
  ...federalHighwayFare,
  cost: convertFromRubToKop(federalHighwayFare.cost)
});

const convertDataFromServer = (federalHighwayFare) => ({
  ...federalHighwayFare,
  cost: convertFromKopToRub(federalHighwayFare.cost)
});

const federalHighwayFare = new CommonApi(
  'federalHighwayFare',
  'Стоимость проезда по федеральным трассам',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...federalHighwayFare
};
